import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { LOGO_WHITE } from "../lib/api";
import { Eye, EyeOff } from "lucide-react";

export default function AdminLogin() {
    const { user, login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPwd, setShowPwd] = useState(false);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    if (user && user.role === "admin") return <Navigate to="/admin" replace />;

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            await login(email.trim().toLowerCase(), password.trim());
            navigate("/admin");
        } catch (err) {
            const d = err.response?.data?.detail;
            setError(typeof d === "string" ? d : "Credenziali non valide");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-black text-white flex items-center justify-center p-6" data-testid="admin-login-page">
            <div className="w-full max-w-md border border-white/15 p-10 relative">
                <img src={LOGO_WHITE} alt="N&M" className="h-10 mb-10" />
                <div className="kicker mb-3">Area riservata</div>
                <h1 className="font-display text-4xl font-extrabold tracking-[-0.03em] mb-8">Accedi</h1>
                <form onSubmit={submit} className="space-y-6" data-testid="admin-login-form">
                    <label className="block">
                        <span className="kicker text-white/60 block mb-2">Email</span>
                        <input
                            type="email"
                            required
                            autoComplete="off"
                            autoCapitalize="off"
                            autoCorrect="off"
                            spellCheck={false}
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full bg-transparent border-0 border-b border-white/30 focus:border-[color:var(--brand-accent)] outline-none py-3"
                            data-testid="admin-email"
                        />
                    </label>
                    <label className="block">
                        <span className="kicker text-white/60 block mb-2">Password</span>
                        <div className="relative">
                            <input
                                type={showPwd ? "text" : "password"}
                                required
                                autoComplete="off"
                                autoCapitalize="off"
                                autoCorrect="off"
                                spellCheck={false}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="w-full bg-transparent border-0 border-b border-white/30 focus:border-[color:var(--brand-accent)] outline-none py-3 pr-10"
                                data-testid="admin-password"
                            />
                            <button
                                type="button"
                                onClick={() => setShowPwd((s) => !s)}
                                className="absolute right-0 top-1/2 -translate-y-1/2 p-2 text-white/50 hover:text-white"
                                tabIndex={-1}
                                aria-label={showPwd ? "Nascondi password" : "Mostra password"}
                                data-testid="toggle-password"
                            >
                                {showPwd ? <EyeOff size={18} /> : <Eye size={18} />}
                            </button>
                        </div>
                    </label>
                    {error && (
                        <div className="text-sm text-red-400 border-l-2 border-red-400 pl-3" data-testid="admin-login-error">
                            {error}
                        </div>
                    )}
                    <button
                        type="submit"
                        disabled={loading}
                        className="btn-primary w-full disabled:opacity-50"
                        data-testid="admin-login-submit"
                    >
                        {loading ? "Accesso…" : "Entra"}
                    </button>
                    <button
                        type="button"
                        onClick={() => {
                            setEmail("admin@nmmanagement.it");
                            setPassword("nmadmin2026");
                        }}
                        className="w-full text-xs text-white/40 hover:text-white/80 underline underline-offset-4"
                        data-testid="fill-credentials"
                    >
                        Riempi credenziali admin (demo)
                    </button>
                </form>
                <div className="mt-10 text-xs text-white/40">
                    Accesso riservato al personale autorizzato.
                </div>
            </div>
        </div>
    );
}
